export default "/_next/static/images/product--bots-legacy-ac0b984db25faf2100e1cdc044a35edf.svg";